import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { SearchResultViewTracker, getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { EcosystemSlider } from 'trellis-ecosystem';
import { useScrollToTop } from '../hooks/useScrollToTop';
import { getSourceIdByCard } from '../utils/usageTracker';
import { StorefrontListingCard } from './cards/StorefrontListingCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SLIDER_HEIGHT = '326px';
export function SliderSection({
  title,
  cards,
  loading,
  productType,
  sectionIndex,
  sectionType,
  seeMoreHref,
  seeMoreText,
  subscreen = 'suggestion section'
}) {
  const scrollToTop = useScrollToTop();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackSuggestionSectionClickEvent = () => trackMarketplaceEvent(getMarketplaceInteractionEvent({
    action: 'see more link clicked',
    itemIndex: sectionIndex,
    section: String(sectionType),
    subscreen,
    type: productType
  }));
  const trackSliderButtonClicked = direction => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: `suggestion section ${direction} arrow clicked`,
      itemIndex: sectionIndex,
      section: String(sectionType),
      subscreen: 'suggestion section',
      type: productType
    }));
  };
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "1000",
    "data-test-id": "slider-section",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        "data-test-id": "slider-section-title",
        marginInlineStart: "-50",
        typography: "heading-300",
        children: title
      }), seeMoreHref && /*#__PURE__*/_jsx(UIRouterLink, {
        to: seeMoreHref,
        onClick: () => {
          scrollToTop();
          trackSuggestionSectionClickEvent();
        },
        children: seeMoreText !== null && seeMoreText !== void 0 ? seeMoreText : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.sliderSection.seeMore"
        })
      })]
    }), loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      blockSize: SLIDER_HEIGHT,
      grow: true
    }) : /*#__PURE__*/_jsx(EcosystemSlider, {
      cardWidth: 306,
      gradientColor: "fill-surface-recessed",
      onScrollButtonClick: trackSliderButtonClicked
      // I've eyeballed this so the center of the scroll buttons aligns with the bottom of the card image background
      ,
      scrollButtonTop: "43.5%",
      children: cards.map((card, index) => /*#__PURE__*/_jsx(SearchResultViewTracker, {
        componentType: "EcosystemListingCard",
        listingId: card.listingId,
        resultCount: cards.length,
        resultIndex: index,
        resultType: "LISTING",
        slug: card.slug,
        sourceId: getSourceIdByCard(card),
        type: productType,
        children: /*#__PURE__*/_jsx(StorefrontListingCard, {
          card: card,
          resultCount: cards.length,
          resultIndex: index,
          marginBlockEnd: "0"
        })
      }, card.listingId))
    })]
  });
}